// types
import { LabelLarge } from 'baseui/typography';
import { ISP_Filter } from './types'
// components
import { Filter3D } from './Filter3D'
import { OperatorPanelWrapperWithChildren } from '../../components/Layout'
import { useStyletron } from 'baseui';
// api
import { FormattedMessage } from 'react-intl';
import { Badge } from 'baseui/badge';

export function OperatorPanel(props: ISP_Filter) {
    const [, theme] = useStyletron();
    const dirty = props.errSum;
    return (
        <OperatorPanelWrapperWithChildren objectId={props.id} resourceGroupId={props.resourceGroupId}
            statusContent={<>
                <Filter3D dirty={dirty} width={100} height={100}></Filter3D>
                {dirty && <Badge hierarchy='secondary' color='warning' content={<FormattedMessage id="SubPlants.DIRTY" defaultMessage="DIRTY" />} />}
                {!dirty && <Badge hierarchy='secondary' color='positive' content={<FormattedMessage id="SubPlants.CLEAN" defaultMessage="CLEAN" />} />}
            </>}>
        </OperatorPanelWrapperWithChildren>
    );
}

